module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("You are dead. Sorry :(")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ccdb304","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/routes/HomeView/dead-player.vue
// module id = 345
// module chunks = 0